import { ShopifyCheckout } from "@shopify/checkout-kit";

import type {
  ShopifyCheckoutCloseEvent,
  ShopifyCheckoutCompleteEvent,
  ShopifyCheckoutErrorEvent,
} from "@shopify/checkout-kit";

/**
 * TODO: WebのCheckout KitにInline(iframe)がまだ取り込まれていないが、ドキュメント上に存在し、時期はTBD(To Be Determined)。
 * 今後、Inline(iframe)が取り込まれたら、この値を"inline"に変更する。
 */
export const SHOPIFY_CHECKOUT_TARGET = "popup" as const;

export const isHttpsCheckoutUrl = (checkoutUrl: string): boolean => {
  try {
    return new URL(checkoutUrl).protocol === "https:";
  } catch {
    return false;
  }
};

type OpenShopifyCheckoutParams = {
  checkoutUrl: string;
  /**
   * 開く窓の名前。クリック中に同じ名前で開いておいた窓があれば、そこへ遷移する。
   * 省略すると新しい popup を開く。
   */
  target?: string;
  onComplete?: (event: ShopifyCheckoutCompleteEvent) => void;
  onClose?: (event: ShopifyCheckoutCloseEvent) => void;
  onError?: (event: ShopifyCheckoutErrorEvent) => void;
};

export const isStorefrontPasswordRequiredError = (
  event: ShopifyCheckoutErrorEvent
): boolean =>
  (event.detail?.error?.messages ?? []).some(
    (message) => message.code === "storefront_password_required"
  );

/**
 * Storefront APIの `cart.checkoutUrl` をCheckout Kitで開く。
 */
export const openShopifyCheckout = ({
  checkoutUrl,
  target,
  onComplete,
  onClose,
  onError,
}: OpenShopifyCheckoutParams): ShopifyCheckout => {
  if (!isHttpsCheckoutUrl(checkoutUrl)) {
    throw new Error("checkoutUrl must be an https URL");
  }

  document.querySelectorAll("shopify-checkout").forEach((element) => {
    element.remove();
  });

  const checkout = new ShopifyCheckout();
  checkout.target = target ?? SHOPIFY_CHECKOUT_TARGET;
  checkout.src = checkoutUrl;

  if (onComplete) {
    checkout.addEventListener("ec.complete", onComplete);
  }
  if (onClose) {
    checkout.addEventListener("ec.close", onClose);
  }
  if (onError) {
    checkout.addEventListener("ec.error", onError);
  }

  document.body.append(checkout);
  checkout.open();
  return checkout;
};
